module.exports = __webpack_public_path__ + "media/images/coingecko-greyscale-b3d1c0a3.png";